import React, { useState, useEffect } from "react";
import CustomNavbar from "../../../components/CustomNavbar";
import { useSelector, useDispatch } from "react-redux";
import SidebarDashboard from "../../../components/seleccionContratacion/SibebarSeleccionContratacion";
import {
  Alert,
  Button,
  ButtonGroup,
  Card,
  Container,
  Row,
  Col,
  Form,
  Modal,
  Spinner,
  Tooltip,
  OverlayTrigger,
  Dropdown,
} from "react-bootstrap";

import moment from "moment";
import * as Yup from "yup";
import { Formik } from "formik";

//Tabla, Navbar y Sidebar
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";
import messages from "../../../redux/messages";

//redux
import {
  deletePais,
  editPaises,
  getPaises,
  savePaises,
} from "../../../redux/seleccionContratacion/pais/actions";

const Pais = (props) => {
  const schema = Yup.object().shape({
    nombre_pais: Yup.string().ensure().required("**Campo requerido"),
    codigo_pais: Yup.number()
      .integer("El número no puede tener decimales.")
      .min(0, "El valor minimo es 0.")
      .required("**Campo requerido"),
  });

  const [show, setShow] = useState(true);
  const onShowSidebar = () => setShow(show ? false : true);

  //
  const [limit, setLimit] = useState(10);
  const [offset, setOffset] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  //
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  //
  const [showFormModal, setShowFormModal] = useState(false);
  const [validated, setValidated] = useState(false);
  const [filter, setFilter] = useState("");

  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre_pais",
    desc: "Nombre país",
  });

  const dispatch = useDispatch();
  const paisStore = useSelector((store) => store.paises);
  const {
    loaderPaises,
    paises,
    paisesFalla,
    saveLoaderPaises,
    paisesFormError,
  } = paisStore;

  //Datos para el custom table

  useEffect(() => {
    _getPaises();
  }, []);

  const pages = Math.ceil((paises ? paises.count : 0) / limit);

  const columns = [
    {
      Header: "Nombre pais",
      accessor: "nombre_pais",
    },
    {
      Header: "Codigo pais",
      accessor: "codigo_pais",
    },
    {
      Header: "Fecha de creación",
      accesor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="button-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  const filters = [
    { id: "nombre_pais", desc: "Nombre país" },
    { id: "codigo_pais", desc: "Código país" },
    { id: "fecha_creacion", desc: "Fecha de creación" },
  ];

  const _getPaises = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getPaises({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter:
          tipoBusqueda.id === "fecha_creacion"
            ? filt !== ""
              ? !isNaN(filt)
                ? filt
                : `${filt.charAt(6)}${filt.charAt(7)}${filt.charAt(
                  8
                )}${filt.charAt(9)}-${filt.charAt(3)}${filt.charAt(
                  4
                )}-${filt.charAt(0)}${filt.charAt(1)}`
              : filt
            : filt,
      })
    );

  const onEdit = (item, index) => {
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowFormModal(true);
    setValidated(false);
  };

  const onDelete = (id, data) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deletePais(id, data));
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getPaises(oOffset, limit, oSearch);
  };

  const onAdd = () => {
    setShowFormModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    _getPaises(oOffset, limit, e.target.filter.value);
  };

  const onSubmit = (req) => {
    console.log(req);
    if (!edit) {
      dispatch(savePaises(req, setShowFormModal));
    } else {
      req.id = editItem.id;
      dispatch(editPaises(req, index, setShowFormModal));
    }
  };

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarDashboard show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h5 className="text-black-50 m-0 text-uppercase">País</h5>
            <Form onSubmit={onSearch}>
              <Form.Row className="justify-content-sm-end align-items-center flex-wrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    type="search"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill mr-1"
                      onClick={() => seeAll()}
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-pill"
                      onClick={() => onAdd()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                    <OverlayTrigger
                      placement="auto"
                      overlay={
                        <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                      }
                    >
                      <Dropdown className="mx-1">
                        <Dropdown.Toggle
                          variant="light"
                          className="btn-sm font rounded-pill"
                        >
                          <i className="material-icons">filter_list</i>
                        </Dropdown.Toggle>
                        <Dropdown.Menu>
                          {filters.map((item) => (
                            <Dropdown.Item
                              onClick={() => setTipoBusqueda(item)}
                              key={item.id}
                            >
                              {item.desc}
                            </Dropdown.Item>
                          ))}
                        </Dropdown.Menu>
                      </Dropdown>
                    </OverlayTrigger>
                  </ButtonGroup>
                </Col>
              </Form.Row>
            </Form>
          </div>
          {!!paisesFalla && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {paisesFalla}
            </Alert>
          )}
          {loaderPaises ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : paises != null && paises.data.length > 0 ? (
            <>
              <Card className="border-0">
                <Card.Body className="px-1 px-sm-2">
                  <CustomTable columns={columns} data={paises.data} />
                </Card.Body>
              </Card>
              <CustomPagint
                limit={limit}
                setLimit={setLimit}
                offset={offset}
                setOffset={setOffset}
                currentPage={currentPage}
                setCurrentPage={setCurrentPage}
                dataLenght={paises.count}
                pages={pages}
                pagFunc={_getPaises}
              />
            </>
          ) : (
            <Alert variant="info" className="my-4">
              Aún no hay registros, comience creando algunos.
            </Alert>
          )}
        </Container>
        {/*Modal editar*/}
        <Modal show={showFormModal} onHide={() => setShowFormModal(false)}>
          <Formik
            validationSchema={schema}
            onSubmit={onSubmit}
            initialValues={{
              nombre_pais: edit ? editItem.nombre_pais : "",
              codigo_pais: edit ? editItem.codigo_pais : "",
            }}
          >
            {({
              handleSubmit,
              handleChange,
              handleBlur,
              //setFieldValue,
              values,
              touched,
              //isValid,
              errors,
            }) => (
              <Form onSubmit={handleSubmit} noValidate validated={validated}>
                <Modal.Header closeButton>
                  <Modal.Title className="ft-modal-title">
                    {edit ? "Editar Pais" : "Crear Pais"}
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  {paisesFormError && typeof paisesFormError !== "object" ? (
                    <Alert variant="danger" className="mt-4 mb-2">
                      {paisesFormError}
                    </Alert>
                  ) : null}
                  <Form.Group as={Col} className="mb-1">
                    <Form.Label column sm="12" md="12">
                      Nombre Pais
                    </Form.Label>
                    <Form.Control
                      name="nombre_pais"
                      className="rounded-pill"
                      required
                      type="text"
                      value={values.nombre_pais}
                      placeholder="nombre pais"
                      onBlur={handleBlur("nombre_pais")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.nombre_pais && !!errors.nombre_pais}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.nombre_pais}
                    </Form.Control.Feedback>
                    {paisesFormError &&
                      typeof paisesFormError === "object" &&
                      paisesFormError.nombre_pais ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {paisesFormError.nombre_pais.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                  <Form.Group as={Col} className="mb-3">
                    <Form.Label column sm="12" md="12">
                      Codigo de Pais
                    </Form.Label>
                    <Form.Control
                      name="codigo_pais"
                      className="rounded-pill"
                      required
                      type="number"
                      value={values.codigo_pais}
                      placeholder="codigo de pais"
                      onBlur={handleBlur("codigo_pais")}
                      onChange={(e) => handleChange(e)}
                      isInvalid={touched.codigo_pais && !!errors.codigo_pais}
                    ></Form.Control>
                    <Form.Control.Feedback type="invalid">
                      {errors.codigo_pais}
                    </Form.Control.Feedback>
                    {paisesFormError &&
                      typeof paisesFormError === "object" &&
                      paisesFormError.codigo_pais ? (
                      <ul className="list-unstyled text-danger ml-2">
                        {paisesFormError.codigo_pais.map((item) => (
                          <li>{item}</li>
                        ))}
                      </ul>
                    ) : null}
                  </Form.Group>
                </Modal.Body>
                <Modal.Footer>
                  <Button
                    className="rounded-pill"
                    variant="secondary"
                    onClick={() => setShowFormModal(false)}
                  >
                    Cerrar
                  </Button>
                  <Button
                    className="rounded-pill"
                    disabled={saveLoaderPaises}
                    variant="primary"
                    type="submit"
                  >
                    {saveLoaderPaises && (
                      <Spinner
                        className="mr-2"
                        as="span"
                        animation="border"
                        size="sm"
                        role="status"
                        aria-hidden="true"
                      />
                    )}
                    Guardar
                  </Button>
                </Modal.Footer>
              </Form>
            )}
          </Formik>
        </Modal>
        {/*Modal*/}
      </div>
    </>
  );
};

export default Pais;